module.exports = __webpack_public_path__ + "static/media/LadyBoneDemonTowerEXTA0035_design_clean_v002.453727aa.png";